<script setup lang="ts">
import type { TProviderCard } from "./shared";
import { BECOME_A_COURSE_PROVIDER_ICONS } from "./shared";

defineProps<{
    card: TProviderCard;
}>();
</script>

<template>
    <div
        class="w-full h-full flex flex-col gap-3 border border-misty-pine-2 rounded-12 p-6"
    >
        <component
            :is="BECOME_A_COURSE_PROVIDER_ICONS[card.icon]"
            class="text-darkGreen text-24"
        />
        <div class="w-full h-full flex flex-col gap-4">
            <h3
                class="font-mulish font-bold text-24 leading-140 text-custom-black"
            >
                {{ card.title }}
            </h3>
            <p
                class="font-mulish font-normal text-16 leading-6 text-custom-black"
            >
                {{ card.description }}
            </p>
        </div>
    </div>
</template>
